<template>
<div class="chapter">
<div class="inner_page">
<h1 class="h1" id="pt01"><a href="#/Text/contents#ipt01">Part I</a></h1>
<h1 class="h1a" id="heading_id_2"><a href="#/Text/contents#ipt01">GLOBAL NOMADS: SURVIVING THE BURN</a></h1>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// part01.vue?0a3b85e0